module.exports = __webpack_public_path__ + "src/assets/img/st9.f01cae14.svg";